import { isEqual } from 'lodash';
import xss from 'xss';

import { NONE, WILDCARD } from './constants';

const PERCENT = '%';
const ENCODING_NUMBER = '25';
const SINGLE_ENCODED_PERCENT = `%${ENCODING_NUMBER}`;
const DOUBLE_ENCODED_PERCENT = `%${ENCODING_NUMBER.repeat(2)}`;

/**
 * @function
 * @description Normalizes URI
 * @see https://github.com/remix-run/history/issues/505
 */
export function normalizeUri(uri: string, { double = false, dedupe = false } = {}) {
    const replacement = double ? DOUBLE_ENCODED_PERCENT : SINGLE_ENCODED_PERCENT;
    const lookAhead = ENCODING_NUMBER.repeat(double ? 2 : 1);
    const regExp = new RegExp(dedupe ? `${PERCENT}(?!${lookAhead})` : PERCENT, 'g');
    return typeof uri === 'string' ? uri.replace(regExp, replacement) : uri;
}

export function normalizeName(name: string) {
    return (
        xss(
            typeof name === 'string'
                ? name
                      .split(/[\s_]/g)
                      .filter(Boolean)
                      .map((part) => part[0].toUpperCase() + part.slice(1))
                      .join(' ')
                : name
        ) || NONE
    );
}

export function formatVersion(version: string) {
    return version || WILDCARD;
}

export function parseVersion(version: string) {
    const decoded = decodeURIComponent(version);
    return decoded === WILDCARD ? '' : decoded;
}

export function noneIf<T>(value: T, reference: T): T | undefined {
    return isEqual(value, reference) ? undefined : value;
}
